import * as React from "react";

type FunctionalChildren = () => (JSX.Element | JSX.Element[])

interface Props extends React.Props<any> {
    condition: boolean
    children: JSX.Element | JSX.Element[] | FunctionalChildren;
}

/**
 * A component that only renders its children if the condition is true.
 */
export function If(props: Props): JSX.Element {
    if (!props.condition) {
        return <React.Fragment />
    }

    let children: JSX.Element | JSX.Element[];

    if (typeof(props.children) === "function") {
        children = props.children();
    } else {
        children = props.children;
    }

    if (Array.isArray(children)) {
        return <React.Fragment>{children}</React.Fragment>
    }

    return children;
}
